module.exports = __webpack_public_path__ + "static/media/WildBoar.7f954c06.jpg";